import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import user from '@/user'
import store from '@/store'
Vue.use(VueRouter)
var router = new VueRouter({
	routes: routes,
	mode: 'hash',
	scrollBehavior: function (to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 }
	}
})

router.beforeEach((to, from, next) => {
	store.commit('FUNNY_PROGRESS_OFF')
	document.title = to.meta.title
	if (user.isGuest() && from.path === '/' && to.path !== '/login' && to.path !== '/monitor') {
		next('/login')
		return false
	}
	if (!user.isGuest() && to.matched.some(record => record.meta.guestOnly)) {
		next('/')
	}
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js